/* eslint-disable import/no-anonymous-default-export */
export default {
  addProject: "Add project",
  editProject: "Edit project",
  viewProject: "View project",
  projectIdHeading: "Project ID",
  projectNameHeading: "Project name",
  taskCountHeading: "Count of allocated tasks",
  projectTitle: "Project",
};
